/**
 * 用户条款
 * Created by Yata on 2017/9/21 0001.
 */

export default [{
    path: '/signIn/:minute',
    component: () => import('../components/signIn/userAgreement.vue')
}]